import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function usePrice(stockCode) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled: !!stockCode,
    staleTime: Infinity,
  });

  return { data, isSuccess, refetch };
}

export default {
  usePrice,
};
